/* eslint-disable react/prop-types */
import CardViewServiceComponent from "./card-view-service";
import { useHistory } from "react-router-dom";
function CardViewService({ item: service }) {
  const history = useHistory();

  const handleClick = () => {
    let path = service.button.link;
    history.push(path);
  };

  return (
    <CardViewServiceComponent
      title={service?.title}
      content={service?.content}
      image={service?.image}
      button={service?.button}
      onLoad={service.onLoad}
      onClick={handleClick}
    />
  );
}

export default CardViewService;
